<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: 'لیست تردد', icon: 'clock-check-outline' }"
    hide-confirm
    max-width="1240"
    reloadable
    @close="resetFields"
    :key="$i18n.locale"
    @reload="handleReload"
  >
    <v-card class="pa-4" flat>
      <v-progress-linear v-show="loading" class="mb-2" indeterminate />
      
      <!-- باکس فیلترهای بالا شامل بازه زمانی و دکمه دانلود اکسل -->
      <v-card class="mx-auto pa-3 rounded-lg mb-4" outlined color="grey lighten-4" elevation="1">
        <v-row align="center">
          <v-col cols="12" md="3">
            <span class="font-weight-bold ml-1">تعداد کل ترددها:</span>
            <strong>{{ use_lang(total) || "-" }}</strong>
          </v-col>
          
          <v-col cols="12" sm="6" md="3">
             <custom-date-picker
                v-model="filters.start_date"
                label="از تاریخ"
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                auto-submit
                hide-details
                @input="fetch()"
             />
          </v-col>

          <v-col cols="12" sm="6" md="3">
             <custom-date-picker
                v-model="filters.end_date"
                label="تا تاریخ"
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                auto-submit
                hide-details
                @input="fetch()"
             />
          </v-col>

          <v-col cols="12" md="3" class="text-left">
            <v-btn
              block
              class="btn-get-code rounded-lg font-weight-bold"
              :loading="downLoading"
              :disabled="downLoading || loading"
              @click="downloadExcel"
            >
              <v-icon left>mdi-file-excel-outline</v-icon>
              خروجی اکسل ترددها
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <vue-table :data="data" :headers="attendanceColumns" @change="onPagination">
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد در صفحه"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="4" md="5">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="جستجو (نام پرسنل، کد)"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="4">
              <v-select
                v-model="filters.type"
                :items="typeOptions"
                label="نوع تردد"
                dense
                outlined
                hide-details
                class="rounded-lg"
                clearable
                @change="fetch()"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{ use_lang(item.index + 1 + (data.current_page - 1) * data.per_page) }}
        </template>

        <template v-slot:fullname="{ item }">
          {{ item.user.name }} {{ item.user.family }}
        </template>
        
        <template v-slot:personal_code="{ item }">
          {{ use_lang(item.user.personal_code) }}
        </template>

        <template v-slot:type="{ item }">
          <v-chip
            :color="item.type === 'ورود' ? 'success' : 'error'"
            small
            dark
            class="font-weight-bold"
          >
            {{ item.type }}
          </v-chip>
        </template>

      </vue-table>
    </v-card>
  </custom-popup>
</template>

<script>
import CustomDatePicker from '../../content/custom-date-picker.vue';

export default {
  name: "AttendanceList",

  components: {
    CustomDatePicker
  },

  props: {
    value: Boolean,
    address: String,
  },

  data() {
    return {
      data: null,
      total: 0,
      records: [],
      
      filters: {
        start_date: null,
        end_date: null,
        type: null,
      },
      
      tableProps: {
        search: "",
        length: 15,
        column: "id",
        dir: "desc",
        page: 1,
      },
      loading: false,
      downLoading: false,

      typeOptions: [
        { text: "همه موارد", value: null },
        { text: "ورود", value: "ورود" },
        { text: "خروج", value: "خروج" },
      ]
    };
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
    attendanceColumns() {
      return [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        { value: "personal_code", text: "کد پرسنلی", align: "center", sortable: false },
        { value: "fullname", text: "نام و نام خانوادگی", align: "center", sortable: false },
        { value: "shift", text: "شیفت کاری", align: "center", sortable: false },
        { value: "type", text: "نوع تردد", align: "center", sortable: false },
        { value: "date", text: "تاریخ", align: "center", sortable: true },
        { value: "time", text: "ساعت", align: "center", sortable: false },
      ];
    },
  },

  watch: {
    value(val) {
      if (val) this.fetch();
    },
  },

  methods: {
    handleReload() {
      this.fetch();
    },

    downloadExcel() {
      this.downLoading = true;
      const params = {
        search: this.tableProps.search || "",
        dir: this.tableProps.dir,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        type: this.filters.type,
      };

      /* --- اتصال API واقعی (کامنت شده) ---
      this.$api.get(`/v1/attendance/records/excel/${this.address || ''}`, { params })
        .then(({ data }) => {
          if (data.download_url) {
            const moment = require('moment-jalaali');
            const a = document.createElement('a');
            a.setAttribute('href', data.download_url);
            a.setAttribute('download', `attendance_${moment().format('jYYYY-jMM-jDD_HH-mm-ss')}.xlsx`);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.$toast.success("فایل ترددها آماده و دانلود شد");
          }
        })
        .catch((err) => {
          console.error("خطا در دانلود اکسل تردد:", err);
          this.$toast.error("خطا در ایجاد خروجی اکسل ترددها");
        })
        .finally(() => {
          this.downLoading = false;
        });
      */

      // شبیه‌سازی تستی
      setTimeout(() => {
        this.downLoading = false;
        this.$toast ? this.$toast.info("درخواست اکسل تردد با بازه زمانی ارسال شد") : console.log("Export attendance", params);
      }, 1000);
    },

    fetch(props = this.tableProps) {
      this.loading = true;
      
      /* --- اتصال API واقعی (کامنت شده) ---
      const queryParams = {
        search: props.search || "",
        dir: props.dir,
        page: props.page,
        length: props.length,
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        type: this.filters.type
      };

      this.$api.get(`/v1/attendance/records/${this.address || ''}`, { params: queryParams })
      .then(({ data }) => {
        this.total = data.data.total;
        this.data = data.data;
        this.records = data.data.data;
      })
      .catch((err) => {
        this.$toast.error("خطا در دریافت لیست تردد");
      })
      .finally(() => {
        this.loading = false;
      });
      */

      setTimeout(() => {
        this.data = {
          current_page: props.page,
          per_page: props.length,
          total: 0,
          data: [
            // { id: 1, user: { personal_code: '1001', name: 'علی', family: 'احمدی' }, type: 'ورود', shift: 'شیفت صبح', date: '1405/07/30', time: '08:05' },
            // { id: 2, user: { personal_code: '1002', name: 'سارا', family: 'محمدی' }, type: 'ورود', shift: 'شیفت صبح', date: '1405/07/30', time: '08:15' },
            // { id: 3, user: { personal_code: '1001', name: 'علی', family: 'احمدی' }, type: 'خروج', shift: 'شیفت صبح', date: '1405/07/30', time: '17:02' },
          ]
        };

        if (this.filters.type) {
          this.data.data = this.data.data.filter(i => i.type === this.filters.type);
        }

        this.total = this.data.total;
        this.loading = false;
      }, 600);
    },

    onPagination(e) {
      const changed =
        e.page !== this.tableProps.page ||
        e.length !== this.tableProps.length ||
        e.search !== this.tableProps.search;

      if (changed) {
        Object.assign(this.tableProps, e);
        this.fetch();
      }
    },

    resetFields() {
      this.records = [];
      this.total = 0;
      this.filters = { start_date: null, end_date: null, type: null };
      this.tableProps = { search: "", length: 15, column: "id", dir: "desc", page: 1 };
    },
  },
};
</script>
